<template>
<BaseModal id="game">
	<template #default="{close}">	
		<div class="modal modal--xxs modal--text-l modal--fullscreen">
			<div class="modal-close" @click="close"></div>
			<div class="modal-form">
				<div class="modal-form__title">Участвуй в игре, <br> получи приз!</div>
				<div class="modal-form__subtitle">В течении минуты, найди все предметы и получи уникальный приз, повышенную
					оценку</div>
				<div class="game">
					<div class="game-world" :class="{'expired': gameStatus === 'Lost'}">
						<div class="game-world__info">
							<div class="game-info">
								<template v-if="gameStatus === 'WaitingForStart' || gameStatus === 'InGame'">
									<div class="game-info__logo">
										<img src="/local/templates/.default/img/logo.svg" alt="Фианит ломбард" loading="lazy">
									</div>
									<div class="game-info__description">На картинке спрятаны предметы, которые «Фианит-Ломбард» с легкостью превращает в деньги. Найдите их за 1 минуту. Время пошло <br> Выигрывайте и получите промокод на пониженную ставку 0.2% </div>
								</template>
								<div v-else class="game-info__repeat">
									<div class="game-info__repeat-text">
										<p>Вы не доглядели. На картинке есть и другие предметы, которые «Фианит-Ломбард» умело превращает в деньги. </p>
										<p>Подсказка, чтобы точно получилось: мы принимаем под залог почти любые ценности от золота до LEGO.</p> 
										<p> Ну что, повторим попытку?</p>
									</div>
									<div class="game-info__repeat-btn">
										<button class="btn color" @click.prevent="restartGame">Новая игра</button>
									</div>
								</div>
								<div class="game-info__timer" :class="{'game-info__timer--expires': timer.time < 10}">
									<div class="game-info__timer-title">Осталось времени</div>
									<div class="game-info__timer-time">0:{{ timer.time < 10 ? '0' : '' }}{{ timer.time }}</div>
								</div>
								<div class="game-info__btn">
									<button class="btn trans" @click.prevent="endGame()">Выйти из игры</button>
								</div>
							</div>
						</div>
						<template v-if="gameSpot === 'room'">
							<div class="game-world__img">
								<div class="game-img">
									<div class="game-img__bg">
										<img src="/local/templates/.default/img/game/room/room.webp" alt="Комната" loading="lazy">
									</div>
									<div class="game-img__objects">
										<img v-for="(object, key) in room.objectPositions" :key="key" 
											:src="`/local/templates/.default/img/game/room/object-${key}.png`" 
											:class="{hide: this.room.objects.get(key)}" 
											@click="setFoundObject(key)" 
											:alt="object.name" 
											loading="lazy" 
											:style="`top: ${object.top}; left: ${object.left}; max-width: ${object.maxWidth};`">
									</div>
								</div>
							</div>
							<div class="game-world__objects">
								<div class="game-objects">
									<img 
										v-for="(object, key) in Array.from(room.objects.values())" :key="key" class="game-objects__item" 
										:class="{'active': !object}"
										:src="`/local/templates/.default/img/game/room/object-preview-${key}.png`" 
										alt="Предмет"
										loading="lazy">
								</div>
							</div>
						</template>
						<template v-else>
							<div class="game-world__img">
								<div class="game-img">
									<div class="game-img__bg">
										<img src="/local/templates/.default/img/game/garage/garage.webp" alt="Гараж" loading="lazy">
									</div>
									<div class="game-img__objects">
										<img v-for="(object, key) in garage.objectPositions" :key="key" 
											:src="`/local/templates/.default/img/game/garage/object-${key}.png`" 
											:class="{hide: this.garage.objects.get(key)}" 
											@click="setFoundObject(key)" 
											:alt="object.name" 
											loading="lazy" 
											:style="`top: ${object.top}; left: ${object.left}; max-width: ${object.maxWidth};`">
									</div>
								</div>
							</div>
							<div class="game-world__objects">
								<div class="game-objects">
									<img 
										v-for="(object, key) in Array.from(garage.objects.values())" :key="key" class="game-objects__item" 
										:class="{'active': !object}"
										:src="`/local/templates/.default/img/game/garage/object-preview-${key}.png`" 
										alt="Предмет"
										loading="lazy">
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</template>
</BaseModal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseModal from "@/components/utils/BaseModal.vue";

export default {
	name: "PopupGame",
	components: {
		BaseModal
	},
	data() {
		return {
			gameStatus: 'WaitingForStart',
			gameSpot: this.gameSpotInitial,
			gameFoundObjects: 0,
			timer: {
				instance: undefined, 
				time: 59,
				timeExpired: false,
			},
			room: {
				objects: new Map(), 
				objectsCount: 14,
				objectPositions: [
					{ name: 'Велосипед', top: '48.8%', left: '52.5%', maxWidth: '18%' },
					{ name: 'Шуруповерт', top: '60.4%', left: '58.7%', maxWidth: '5%' },
					{ name: 'Шуба', top: '44.4%', left: '92%', maxWidth: '8%' },
					{ name: 'Коньки', top: '60%', left: '65.7%', maxWidth: '5%' },
					{ name: 'Лего', top: '43%', left: '29.7%', maxWidth: '5%' },
					{ name: 'Фигурка', top: '23%', left: '88%', maxWidth: '5%' },
					{ name: 'Отпариватель', top: '42%', left: '68%', maxWidth: '5%' },
					{ name: 'Телевизор', top: '52%', left: '82%', maxWidth: '11%' },
					{ name: 'Пылесос', top: '64.2%', left: '10.7%', maxWidth: '10%' },
					{ name: 'Часы', top: '65%', left: '51%', maxWidth: '2%' },
					{ name: 'Шкатулка', top: '62%', left: '74%', maxWidth: '8%' },
					{ name: 'Колонка', top: '70%', left: '87.7%', maxWidth: '10%' },
					{ name: 'Планшет', top: '62%', left: '26.7%', maxWidth: '5%' },
					{ name: 'Ноутбук', top: '61%', left: '41.7%', maxWidth: '7%' }
				],
			},
			garage: {
				objects: new Map(), 
				objectsCount: 14,
				objectPositions: [
					{ name: 'Холодильник', top: '50%', left: '32%', maxWidth: '12%' },
					{ name: 'Кресло', top: '58.4%', left: '25%', maxWidth: '16%' },
					{ name: 'Велосипед', top: '57%', left: '62%', maxWidth: '18%' },
					{ name: 'Самокат', top: '63.5%', left: '60%', maxWidth: '16%' },
					{ name: 'Авто', top: '60%', left: '33.9%', maxWidth: '40%' },
					{ name: 'Шуруповерт', top: '58.5%', left: '18.8%', maxWidth: '5%' },
					{ name: 'Шуба', top: '42.5%', left: '67.4%', maxWidth: '6%' },
					{ name: 'Приставка', top: '74%', left: '2%', maxWidth: '5%' },
					{ name: 'Монеты', top: '76.6%', left: '89%', maxWidth: '3%' },
					{ name: 'Гриль', top: '68.1%', left: '12%', maxWidth: '8%' },
					{ name: 'Коньки', top: '43.1%', left: '14%', maxWidth: '6%' },
					{ name: 'Телевизор', top: '27.5%', left: '13.6%', maxWidth: '7%' },
					{ name: 'Сноуборд', top: '58.2%', left: '83.3%', maxWidth: '5%' },
					{ name: 'Инструменты', top: '57%', left: '89%', maxWidth: '8%' },
				],
			},

		}
	},
	mounted() {
		this.fillGameObjects()

		this.$watch('getModalOpened', () => {
            if (this.isModalOpened('game')) {
				this.resetTimer()
				this.startGame()
            }
        }, {immediate: false})
	},
	methods: {
		startGame() {
			this.gameStatus = 'InGame'
			this.startTimer()
		},
		fillGameObjects() {
			for(let i = 0; i < this.room.objectsCount; i++) {
				this.room.objects.set(i, false)
				this.garage.objects.set(i, false)

			}
		},
		startTimer() {
			this.timer.instanse = setInterval(() => {
				this.timer.time--;
				if (this.timer.time === 0) {
					this.gameStatus = "Lost"
					this.resetTimer();
				}
			}, 1000);
		},
		resetTimer() {
			this.timer.timeExpired = true
			clearInterval(this.timer.instanse)
			this.timer.time = 59
			this.fillGameObjects()
		},
		restartGame() {
			this.gameFoundObjects = 0
			this.gameStatus = 'InGame'
			this.startTimer()
		},

		endGame(close = true) {
			this.resetTimer()
			this.gameStatus = 'WaitingForStart'
			this.gameFoundObjects = 0
			if(close) {
				this.closeModal('game')
			}
		},
		setFoundObject(key) {
			this.gameFoundObjects++
			if(this.gameSpot === 'room') {
				this.room.objects.set(key, true)
				if (this.gameFoundObjects === this.room.objectsCount) {
					this.closeModal('game')
					this.endGame(false)
					this.openModal('win-promocode');
				}
			} else {
				this.garage.objects.set(key, true)
				if (this.gameFoundObjects === this.garage.objectsCount) {
					this.closeModal('game')
					this.endGame(false)
					this.openModal('win-promocode');
				}
			}
		},
		...mapActions({
			openModal: 'modals/openModal',
			closeModal: 'modals/closeModal',
		})
	},
	watch: {
		gameSpotInitial: {
			handler: function (newValue) {
				this.gameSpot = newValue
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			gameSpotInitial: 'game/getGameSpot',
			getModalOpened: 'modals/getModalOpened',
			isModalOpened: 'modals/isModalOpened',
		})
	}
}
</script>

<style scoped></style>